// extracted by mini-css-extract-plugin
module.exports = {"error":"styles__error--3PqcG","success":"styles__success--3u25l","tableHeader":"styles__tableHeader--2KttG"};